/* Cloofs – Collectiepagina (sections/cloofs-main-collection): sorteren, filterpaneel openen/sluiten, "Meer tonen" bij
   lange filterlijsten en "Meer laden" (houdt de klasse has-more bij, zodat de rijen met campagnetegel vol blijven).
   Zonder JavaScript werkt alles ook: het filterformulier verstuurt gewoon, "Meer laden" is een link naar de volgende pagina.
   Het filterpaneel zet html.lock-scroll, zodat de pagina erachter stil blijft (zie snippets/cloofs-layout). */
(() => {
  if (customElements.get('cloofs-collection')) return;

  class CloofsCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.filters = this.querySelector('[data-filters]');
      this.openBtn = this.querySelector('[data-filter-open]');

      const sort = this.querySelector('[data-sort]');
      if (sort) sort.addEventListener('change', () => this.sortBy(sort.value));

      if (this.filters) {
        this.openBtn.addEventListener('click', () => this.open());
        this.filters.querySelectorAll('[data-filter-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.filters.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
        const form = this.filters.querySelector('[data-filter-form]');
        // Lege prijsvelden niet meesturen (schonere URL)
        form.addEventListener('submit', () => {
          form.querySelectorAll('input[type="number"]').forEach((input) => { if (input.value === '') input.disabled = true; });
        });
      }

      this.addEventListener('click', (e) => {
        const more = e.target.closest('[data-load-more]');
        if (more) { e.preventDefault(); this.loadMore(more); return; }
        const showAll = e.target.closest('[data-filter-more]');
        if (showAll) {
          const list = showAll.previousElementSibling;
          if (list) list.classList.add('is-expanded');
          showAll.remove();
        }
      });
    }

    sortBy(value) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    open() {
      this.filters.hidden = false;
      document.documentElement.classList.add('lock-scroll');
      this.openBtn.setAttribute('aria-expanded', 'true');
      void this.filters.offsetWidth; // eerst tonen, dan inschuiven (zodat de overgang zichtbaar is)
      this.filters.classList.add('is-open');
      const close = this.filters.querySelector('.cloofs-filters__close');
      if (close) close.focus({ preventScroll: true });
    }

    close() {
      if (this.filters.hidden) return;
      this.filters.classList.remove('is-open');
      this.openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lock-scroll');
      setTimeout(() => { this.filters.hidden = true; }, 300);
      this.openBtn.focus({ preventScroll: true });
    }

    loadMore(btn) {
      btn.classList.add('is-loading');
      const url = new URL(btn.href, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);
      fetch(url.toString())
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = this.querySelector('[data-grid]');
          const newItems = doc.querySelectorAll('[data-grid] > li');
          newItems.forEach((li) => grid.appendChild(document.importNode(li, true)));
          const newGrid = doc.querySelector('[data-grid]');
          grid.classList.toggle('has-more', !!(newGrid && newGrid.classList.contains('has-more')));
          const newMore = doc.querySelector('[data-more]');
          const more = this.querySelector('[data-more]');
          if (newMore && more) more.replaceWith(document.importNode(newMore, true));
        })
        .catch(() => { window.location.href = btn.href; });
    }
  }

  customElements.define('cloofs-collection', CloofsCollection);
})();
